import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { currentLang } from '../../../utils/functions';

const STORAGE_KEY = 'noticeBannerDismissed_de_farmshop';

const NoticeBanner = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const lang = currentLang();
  const normalizedPath = pathname.replace(/\/$/, '') || '/';

  // NL homepage only (`/nl`)
  const isNlHome = lang === 'nl' && normalizedPath === '/nl';
  // DISABLED!!! DO NOT ENABLE WITHOUT CHECKING WITH KHALIL OR ANNA
  const isDeFarmshop = false; // = lang === 'de' && pathname.startsWith('/de/farmbox');
  const shouldShowBanner = isNlHome;

  // Call all hooks unconditionally (React rules of hooks)
  useEffect(() => {
    if (!isDeFarmshop) return;
    try {
      if (localStorage.getItem(STORAGE_KEY) === 'true') {
        setIsVisible(false);
      }
    } catch (e) {
      // ignore storage errors
    }
  }, [isDeFarmshop]);

  const handleClose = () => {
    setIsVisible(false);
    if (isDeFarmshop) {
      try {
        localStorage.setItem(STORAGE_KEY, 'true');
      } catch (e) {
        // ignore
      }
    }
  };

  // Early returns only after all hooks have been called
  if (!shouldShowBanner) {
    return null;
  }
  if (!isVisible) {
    return null;
  }

  return (
    <div className="notice-banner">
      <div className="container">
        <div className="notice-banner__content">
          <div className="notice-banner__text">
            {lang === 'de' && (
              <span className="notice-banner__icon" aria-hidden="true">
                <i className="icon-gift-fill" />
              </span>
            )}
            <span className="notice-banner__text-inner">
              {parse(t('notice_banner.text'))}
            </span>
          </div>
          <button
            className="notice-banner__close"
            onClick={handleClose}
            aria-label="Schließen"
          >
            <span>&times;</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoticeBanner;
